module.exports = __webpack_public_path__ + "static/media/orthene_ultra.2759d09d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/climasense/picudo_pimiento/curativa/orthene_ultra.png
// module id = 2207
// module chunks = 3